import * as $ from "jquery";
import * as ko from "knockout";
import { BaseViewModel, HttpAction } from "./baseviewmodel";
import { ResponseContainer } from "../Models/responsecontainer";
import { UserTeam, UserTeamMin } from "../Models/userteam";
import { Event } from "../Models/event";
import Chart = require("chart.js");
import { ChartPointItem } from "../Models/ChartPoint";
import { AzureStatus } from "../Models/AzureStatus";

class DashboardViewModel extends BaseViewModel {    
    public activeUsersOutputValues = ko.observableArray<UserTeam>(null);
    public newSubscriptionsOutputValues = ko.observableArray<ChartPointItem>(null);
    public newTrialsOutputValues = ko.observableArray<ChartPointItem>(null);
    public current7DaysNewSubsOutputValues = ko.observableArray<UserTeamMin>(null);
    public activeUsersCountOutputValue = ko.observable<number>(0);
    public azureStatusOutputValue = ko.observable<AzureStatus>(null);

    constructor(paramters: string) {
        super(paramters);

        this.classname = "DashboardViewModel";

        this.autoRefresh = true;
        this.refresh();

    }

    public refresh(parameters?: string) {
        var self = this;
        this.getJsonData(`/api/accounts`,
            (data: UserTeam[]) => {
                self.activeUsersOutputValues(data);
            },
            (err) => {
                console.log(err);
            }, null);

        this.getJsonData(`/api/accounts/activecount`,
            (data: number) => {
                self.activeUsersCountOutputValue(data);
            },
            (err) => {
                console.log(err);
            }, null);

        this.getJsonData(`/api/accounts/newsubscriptions`,
            (data: ChartPointItem[]) => {
                self.newSubscriptionsOutputValues(data);
                self.setupChartData(self.newTrialsOutputValues(), self.newSubscriptionsOutputValues());
            },
            (err) => {
                console.log(err);
            }, null);

        this.getJsonData(`/api/accounts/newtrials`,
            (data: ChartPointItem[]) => {
                self.newTrialsOutputValues(data);
                self.setupChartData(self.newTrialsOutputValues(), self.newSubscriptionsOutputValues());
            },
            (err) => {
                console.log(err);
            }, null);

        this.getJsonData(`/api/accounts/newsubscriptions7days`,
            (data: UserTeamMin[]) => {
                self.current7DaysNewSubsOutputValues(data);
            },
            (err) => {
                console.log(err);
            }, null);

        this.getJsonData(`/api/accounts/status`,
            (data: AzureStatus) => {
                self.azureStatusOutputValue(data);
            },
            (err) => {
                console.log(err);
            }, null);
    }

    public showActiveUsers() {
        this.navigateTo("home", "accounts", "Accounts", "accounts", "is:online");
    }

    public showNewSubscriptions() {
        this.navigateTo("home", "accounts", "Accounts", "accounts", "is:newsubscription");
    }

    public showNewTrials() {
        this.navigateTo("home", "accounts", "Accounts", "accounts", "is:newtrial");
    }

    setupChartData(data1: ChartPointItem[], data2: ChartPointItem[], ): void {
        // Create chart data      
        // tslint:disable-next-line
        var labels: any = [];

        data1.forEach((value) => {
            labels.push(value.key);
        });

        var chartData1: number[] = [];
        data1.forEach((value) => {
            chartData1.push(value.value);
        });

        var chartData2: number[] = [];
        data2.forEach((value) => {
            chartData2.push(value.value);
        });
        
        const chartColors = [
            "#00A7B5", // (Turquise)
            "#DA1884", // (pink)
        ];        

        let canvas = document.getElementById('chartCanvas') as HTMLCanvasElement;
        let context = canvas.getContext("2d");

        let chart: Chart = new Chart(context, {
            type: 'bar',
            data: {
                labels: labels,
                datasets: [{
                    label: 'New Trials',
                    data: chartData1,
                    backgroundColor: chartColors[0],
                    borderWidth: 1,
                    borderColor: chartColors[0]
                }, {
                    label: 'New Subscriptions',
                    data: chartData2,
                    backgroundColor: chartColors[1],
                    borderWidth: 1,
                    borderColor: chartColors[1]
                }]
            },
            options: {
                scales: {
                    yAxes: [{
                        ticks: {
                            min: 0,
                            beginAtZero: true,
                            callback: function (value, index, values) {
                                if (Math.floor(value) === value) {
                                    return value;
                                }
                            }
                        }
                    }]

                }
            }
        });
        chart.update();

    }
}

export { DashboardViewModel };



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./Scripts/ViewModels/dashboardviewmodel.ts